export default {
  main: {
    hero: `
        我们的游戏<br/>
        创造了充满<strong>活力的</strong>世界<br/>
        和<strong>丰富的</strong>角色
      `,
    homescapes: `Scapes™ 系列的史诗级作品，玩家可以与管家奥斯汀一起修复一座美丽的宅邸`,
    township: `一款有着丰富活动、竞赛和玩家锦标赛的趣味城市建设游戏`,
  },
  common: {
    login: '登入',
    logout: '登出',
    support: '帮助',
    privacy: '隐私政策',
    terms: `服务条款`,
    and: '以及',
    guest: '访客',
    play: '开始游戏',
    install: '安装',
  },
  support: {
    title: `是否需要帮助？`,
    description: `如果您是此游戏的用户，您遇到任何问题时，
      我们将竭诚为您提供帮助，解答您的所有问题`,
    button: '@:common.support',
  },
  homescapes: {
    title: '梦幻家园',
    caption: '帮助管家奥斯汀把温暖与舒适带回美好的祖宅。',
    description: `帮助管家奥斯汀把温暖与舒适带回美好的祖宅。
      快进来吧——从你踏进大门的那一刻起，
      就会开始无穷无尽的精彩奇遇！`,
    xsolla: 'Xsolla 公司是《梦幻家园》游戏授权的全球经销商',
    install: {
      title: '@:common.install',
      text: `在电脑上畅玩《梦幻家园》！
      安装游戏的网页版，只要按几下鼠标就能找到奥斯汀！`,
      button: '@:common.install',
    },
  },
  township: {
    title: '梦想城镇',
    caption: `收获农作物、在工厂进行加工，
      再将货物出售，不断发展您的小镇`,
    description: `收获农作物、在工厂进行加工，
      再将货物出售，不断发展您的小镇`,
    xsolla: 'Xsolla 公司是《梦想城镇》游戏授权的全球经销商',
    install: {
      title: '@:common.install',
      text: `在桌面上玩《梦幻小镇》！
      安装网页版游戏，只需点击几下就能访问你的城镇！`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: '本网站使用本地端的小型文本文件，以保证您使用本网站时的最佳体验',
    link: `更多信息`,
    button: '接受',
  },
  game: {
    notSupported: `不支持移动设备。请从电脑登录进行游戏。`,
  },
};
